import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  @ViewChild('file') file: ElementRef;

  @Input() uploadActive: boolean;

  @Output() uploadData = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  processWorkbook(workbook) {
    const sheetName = workbook.SheetNames[0];
    this.file.nativeElement.value = null;

    const accounts = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

    this.uploadData.next(accounts);
  }

  upload(e) {
    const files = e.target.files;
    let i, f;
    for (i = 0, f = files[i]; i !== files.length; ++i) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target['result'];

        const workbook = XLSX.read(data, {type: 'binary'});
        this.processWorkbook(workbook);
      };
      reader.readAsBinaryString(f);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/components/settings/upload/upload.component.ts